export default {
  title: {
    en: 'Our biggest sale of the year [get 20% off]',
  },
}
